






















import { Component, Prop, Vue } from "vue-property-decorator";
import { User } from "@/api/models/User";

@Component
export default class PraesidiumOntgroend extends Vue {
    /**
     * List with ontgroende schachten.
     */
    @Prop()
    users: Array<User>;
}
